import US_FLAG from 'common/images/us-flag.png';
import CAN_FLAG from 'common/images/can-flag.png';

const countryFlag = countryCode => {
  return countryCode === 'CA' ? CAN_FLAG : US_FLAG;
};

export default countryFlag;
